module.exports = __webpack_public_path__ + "img/file3.17f0bfc4.png";